import { useState, useRef, useEffect } from 'react'
import axios from 'axios'

function Commenti({ onChiudi, flag, email, idEvento, userIdEvento, img, titolo, messaggiLength, disabledNotificaEmail, disabledComment }) {
    const [messaggi, setMessaggi] = useState([])
    const [counter, setCounter] = useState(0) // counter per id ai messaggi
    const [impostazioniComment, setImpostazioniComment] = useState({
        setComment: '',
        setEmail: '',
    })
    const [formData, setFormData] = useState({
        idEvento: idEvento,
        disabledNotificaEmail: disabledNotificaEmail,
        email: email,
        titolo: titolo
    })
    const impostazioni = useRef()
    const myDIV = useRef()
    const messageSubmit = useRef()
    let idUtente = localStorage.getItem('idUser')

    function handleInputChange(e) {
        const { value, type, checked } = e.target//attributi degli input
        const inputValue = type === "checkbox" ? checked : value//se type=checkbox valorizza checked altrimenti valorizza value
        if (!inputValue.trim().length || inputValue === '') {
            messageSubmit.current.style.display = 'none'; return
        }
        messageSubmit.current.style.display = 'inline'//rendo visibile l'icona di invio messaggio
        setFormData({ ...formData, messaggio: !inputValue.trim().length || inputValue === '' ? null : inputValue })
    }
    async function removeMessage(e) {
        const idDomDaRimuovere = e.target.getAttribute('data-val')//id che identifica il paragrafo creato (da rimuovere)
        const idMessaggioMysql = e.target.getAttribute('idMysql')//id che identifica il messaggio in Mysql (appena inserito) da rimuovere
        const domDaRimuovere = document.getElementById(idDomDaRimuovere)
        domDaRimuovere.style.transition = '1s'
        domDaRimuovere.style.opacity = '.2'
        setTimeout(() => {
            document.getElementById('idInvioMessaggio').innerHTML = ''
            domDaRimuovere.innerHTML = ""
        }, 1000)
        try {
            const res = await axios.get(`/removeComment/${idMessaggioMysql}`)
            if (res.data.message !== 'success') {// callback failed
                const invio = document.createElement("p")
                invio.innerHTML = 'problemi di connessione ⛔'
                invio.style.textAlign = 'center'
                invio.setAttribute("id", 'idInvioMessaggio')
                invio.className = 'paragrafo'
                setTimeout(() => {//creo l'elemento sotto al messaggio
                    myDIV.current.appendChild(invio)
                }, 500)
            } else { // callback success
                messaggiLength(prevCount => prevCount - 1)// decremento messaggiLength per UI del numero dei messaggi in tempo reale
                setMessaggi((prevMessaggi) =>
                    prevMessaggi.filter((messaggio) => messaggio.id !== idMessaggioMysql)
                )
            }
        } catch (err) { console.log(err) }
    }
    async function handleSubmit(e) {
        e.preventDefault()//al onSubmit la pagina non si aggiorna perchè abbiamo prevenuto il default
        messageSubmit.current.style.display = 'none'
        document.getElementById('messaggioFromTextArea').value = ''
        const idUser = ottieniOInizializzaIdUtente()

        const newFormData = { ...formData, idUser: idUser }
        try {
            const res = await axios.post(`/createComment`, newFormData)
            if (res.data.message === 'success') {
                const para = document.createElement("p")
                para.innerHTML = `
                            <p style="opacity: .8; font-size:small">${new Date().toISOString().slice(0, 10).split("-").reverse().join("-")}
                                <button style="border:none; float:right; background-color:transparent" 
                                data-val="mess${counter}" idMysql="${res.data.result}">❌</button>
                            </p> 
                            <p>${formData.messaggio}</p>`
                para.style.boxShadow = '8px 8px 10px grey'
                para.style.backgroundColor = 'silver'
                para.style.borderRadius = '10px'
                para.style.width = '95%'
                para.style.margin = '1em 0 0 0'
                para.style.padding = '0 .5em'
                para.style.fontFamily = 'Times New Roman'
                para.className = 'paragrafo'
                para.id = "mess" + counter
                para.onclick = removeMessage
                myDIV.current.appendChild(para)

                setCounter(counter + 1) // incremento counter per dare il nuovo id al prox messaggio ("mess" + counter)
                messaggiLength(prevCount => prevCount + 1)// incremento messaggiLength per UI del numero dei messaggi in tempo reale

                //avanzamento scrolling Y ad ogni invio messaggio
                const bnm = document.getElementsByClassName('paragrafo')
                bnm[bnm.length - 1].scrollIntoView()

                //creazione paragrafo 'messaggio inviato' ad ogni messaggio inviato dall'utente
                const check = document.getElementById('idInvioMessaggio')
                if (check !== null) {//se l'elemento 'inviato' esiste, lo rimuovo 
                    document.getElementById('idInvioMessaggio').remove()
                }
                const invio = document.createElement("p")
                invio.innerHTML = 'inviato ✔'
                invio.style.textAlign = 'center'
                invio.setAttribute("id", 'idInvioMessaggio')
                invio.className = 'paragrafo'
                setTimeout(() => {//creo l'elemento 'inviato' sotto al messaggio
                    myDIV.current.appendChild(invio)
                }, 500)
            } else {
                const invio = document.createElement("p")
                invio.innerHTML = 'problemi di connessione ⛔'
                invio.style.textAlign = 'center'
                invio.setAttribute("id", 'idInvioMessaggio')
                invio.className = 'paragrafo'
                setTimeout(() => {//creo l'elemento sotto al messaggio
                    myDIV.current.appendChild(invio)
                    //avanzamento scrolling Y ad ogni invio messaggio
                    const bnm = document.getElementsByClassName('paragrafo')
                    bnm[bnm.length - 1].scrollIntoView()
                }, 500)
            }
        } catch (err) { console.log(err) }
        setFormData({ ...formData, messaggio: null })
    }
    function pressImpostazioni(e) {
        switch (impostazioni.current.style.left) {
            case "120%": { impostazioni.current.style.left = '40%'; break }
            case "40%": impostazioni.current.style.left = '120%'; break
            default:
        }
    }
    async function handleImpostazioniComment(e) {
        let qw, stato
        // settaggio abilita o disabilita i commenti dell'evento --------------------------------------------------------------------
        if (e === 'setComment') {
            const content = document.getElementById('messaggioFromTextArea')
            if (impostazioniComment.setComment === 'commenti abilitati') {
                qw = 'commenti disabilitati'; stato = 'true'
                content.value = `Commenti disabilitati, vai in impostazioni per abilitarli.`
                content.disabled = true; messageSubmit.current.style.display = 'none'
            }
            if (impostazioniComment.setComment === 'commenti disabilitati') {
                qw = 'commenti abilitati'; stato = 'false'
                content.value = ``; content.disabled = false; messageSubmit.current.style.display = 'inline'
            }
            setImpostazioniComment({ ...impostazioniComment, setComment: qw })
        }

        // settaggio notifica email quando si commenta l'evento --------------------------------------------------------------------
        if (e === 'setEmail') {
            if (impostazioniComment.setEmail === 'notifica email abilitata') { qw = 'notifica email disabilitata'; stato = 'true' }
            if (impostazioniComment.setEmail === 'notifica email disabilitata') { qw = 'notifica email abilitata'; stato = 'false' }
            setImpostazioniComment({ ...impostazioniComment, setEmail: qw })
        }

        const res = await axios.get(`/setComment/${e}/${stato}/${idEvento}`)
        if (res.data.message === 'success') {
            setTimeout(() => {
                impostazioni.current.style.left = '120%'
            }, 1500)
        }
    }
    async function getMessage() {
        const response = await axios.post(`/getCommenti`)
        setMessaggi(response.data.filter(x => x.idEvento === parseInt(idEvento) && x.messaggio !== 'sono_il_creatore'))
        messaggiLength(response.data.filter(x => x.idEvento === parseInt(idEvento) && x.messaggio !== 'sono_il_creatore').length) //per numero di messaggi
    }
    function ottieniOInizializzaIdUtente() {// Funzione per ottenere l'ID utente persistente
        if (!idUtente || idUtente === 'null' || idUtente === 'undefined' || idUtente.trim() === '') {
            idUtente = Math.random().toString(36).slice(2, 11)
            localStorage.setItem('idUser', idUtente)
        }
        return idUtente
    }
    useEffect(() => {
        if (disabledComment === 'true') {// check se il possessore dell'evento ha disabilitato i commenti
            const content = document.getElementById('messaggioFromTextArea')
            content.value = `Commenti disabilitati`
            content.disabled = true
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [disabledComment])

    useEffect(() => {
        if (flag === 'primoMessGenitore' && idUtente) {//utente ha cliccato icona messaggi
            async function setStato() {//aggiorno il campo 'stato' che controlla la pallina rossa in notifiche
                const res = await axios.get(`/setStatoNotifica/${idEvento}/${idUtente}`)
                console.log(res.data.messaggio)
            }
            setStato()
        }
    }, [flag])

    useEffect(() => { getMessage() }, [])
    // useEffect(() => { console.log(messaggi) }, [messaggi])
    return (<>
        <div className={`${flag === 'primoMessGenitore' ? 'divMessaggiAperto' : 'divMessaggi'}`}>
            <div style={{ padding: '.5em 1.5em', backgroundColor: 'whitesmoke' }}>
                <span onClick={() => {
                    impostazioni.current.style.left = '120%'; onChiudi()
                }} style={{ marginRight: '1.5em', fontSize: 'xx-large', cursor: 'pointer' }}>
                    ◀
                </span>
            </div> <hr style={{ borderTop: '2px solid black' }} />

            <div style={{ padding: '0 1.5em .2em 1.5em', display: 'grid', gridTemplateColumns: '0.25fr 1fr', gap: '5px' }}>
                <div>
                    {img.length !== 0 ? //evento con almeno una foto caricata dall'utente
                        <img src={`https://leuro-bucket.s3.amazonaws.com/${img[0]}`} style={{ borderRadius: '50%', width: '50px', height: '50px' }} alt='' />
                        :
                        <img src={"https://leuro-bucket.s3.amazonaws.com/evento_senza_foto.jpg"} style={{ borderRadius: '50%', width: '50px', height: '50px' }} alt='' />
                    }
                </div>
                <div style={{ fontSize: '16px', fontWeight: '600' }}>{titolo} </div>
            </div>
            {/* ----------------- CRONOLOGIA DEI COMMENTI ---------------------- */}
            <div style={{ overflowY: 'scroll', height: '60%', scrollBehavior: 'smooth', border: '1px solid silver', borderRadius: '10px', margin: '0 10px' }}
                className='bodyPadding'>
                {messaggi.length !== 0 && messaggi.map((messaggio) => {
                    let margine = '1em 0 0 0'
                    return (
                        <div key={messaggio.id} style={{
                            boxShadow: '8px 8px 10px grey', backgroundColor: 'silver', border: '1px solid lightgrey', borderRadius: '10px',
                            width: '95%', margin: margine, padding: '0 .5em', overflowX: 'auto', fontFamily: 'Times New Roman'
                        }}>
                            <p style={{ fontSize: 'small', opacity: '.8', display: 'inline' }}>{new Date(messaggio.created_at).toISOString().slice(0, 10).split("-").reverse().join("-")}</p>
                            <div style={{ float: 'right', paddingTop: '.5em' }}>
                                {messaggio.fotoMittente ? //evento con almeno una foto caricata dall'utente
                                    <img src={`https://leuro-bucket.s3.amazonaws.com/${messaggio.fotoMittente}`} style={{ borderRadius: '50%', width: '40px', height: '40px' }} alt='' />
                                    ://evento senza foto
                                    <img src={require('../image/icons8-impostazioni-amministratore-maschio-32.png')} style={{ borderRadius: '50%', width: '30px', height: '30px' }} alt='' />
                                }
                            </div>
                            <p>{messaggio.messaggio}</p>
                        </div>
                    )
                })
                }
                {/* ------------------ MESSAGGI INVIATI DAL INPUT nel BOTTOM ----------- */}
                <div ref={myDIV} style={{ marginBottom: '2em' }}>
                    {/* ------------ qui vengono iniettati i messaggi inviati ---------- */}
                </div>
            </div>
            {/* ------------------- INPUT DEI COMMENTI ------------------ */}
            <form onSubmit={handleSubmit}>
                <div style={{ width: '100%', position: 'absolute', bottom: '10px', left: '1.5em' }}>
                    <textarea className="form-control" style={{
                        border: '3px solid dodgerblue', width: '65%', display: 'inline', fontSize: 'medium'
                    }}
                        id='messaggioFromTextArea' type='text' onChange={handleInputChange} maxLength={500} name='messaggio' rows={2} placeholder='messaggio'
                    />
                    <input ref={messageSubmit} // icona invio messaggio
                        type='image' name='submit' src={require('../image/icons8-invia-e-mail-48.png')} width={'33em'} border="0" alt="Submit"
                        style={{ margin: '0 0 .5em 5px', display: 'none' }}
                    />
                </div>
            </form>
        </div>
        {/* ------------------- BANNER DELLE IMPOSTAZIONI COMMENTI solo se l'evento è del loggato ----------------------- */}
        <div ref={impostazioni} style={{
            backgroundColor: 'white', height: '83%', width: '60%', position: 'fixed', bottom: '0', left: '120%',
            zIndex: '2', transition: '.2s', border: '1px solid lightgray'
        }}>
            <img src={require('../image/icons8-chiudi-macos-32.png')} alt='' onClick={() => {
                impostazioni.current.style.left = '120%'
            }} style={{ float: 'right', margin: '1em .5em 0 0', cursor: 'pointer' }} />
            <h4 className='mt-5 text-center'>IMPOSTAZIONI</h4> <hr />
            {/* --------------- DISABILITA - ABILITA CHAT --------------- */}
            <div className='mt-3' style={{ margin: '1em' }}>
                <button type='button' style={{ borderRadius: '25px' }} onClick={() => { handleImpostazioniComment('setComment') }}>Commenti on/off</button>
                <div style={{ fontSize: 'small', marginTop: '1em' }}>
                    <i>{impostazioniComment.setComment}</i>
                    <span style={{ margin: '1em 0 0 1em' }}>
                        {impostazioniComment.setComment === 'commenti abilitati' ? '✅' : '⛔'}
                    </span>
                </div>
            </div><hr />
            {/* ---------------- DISABILITA - ABILITA NOTIFICA CON EMAIL ----------------- */}
            <div className='mt-3' style={{ margin: '1em' }}>
                <button type='button' style={{ borderRadius: '25px' }} onClick={() => { handleImpostazioniComment('setEmail') }}>Notifica email on/off</button>
                <div style={{ fontSize: 'small', marginTop: '1em' }}>
                    <i>{impostazioniComment.setEmail}</i>
                    <span style={{ margin: '1em 0 0 1em' }}>
                        {impostazioniComment.setEmail === 'notifica email abilitata' ? '✅' : '⛔'}
                    </span>
                </div>
            </div>
        </div>
    </>)
}
export default Commenti